import { useCallback } from 'react';
import type { ExtendedReminderInvitationsFormValues } from '../../../../../../invitations-form-content';
import type { EventCreateParticipant } from '../../../../../../types';

type DistributionListItem = {
  communityId: string;
  communityName: string;
};

type InvitationsRequestData = {
  distributionList: DistributionListItem[];
  participants: EventCreateParticipant[];
};

export const useGetInvitationsRequestData = () =>
  useCallback((formValues: ExtendedReminderInvitationsFormValues): InvitationsRequestData => {
    const invitations = formValues.invitations ?? [];

    return {
      distributionList: invitations
        .filter((invitation) => invitation.type === 'community')
        .map((invitation) => ({
          communityId: invitation.value,
          communityName: invitation.label,
        })),
      participants: invitations
        .filter((invitation) => invitation.type !== 'community')
        .map((invitation) => ({
          ref: invitation.value,
          role: 'attendee',
          type: 'user',
        })),
    };
  }, []);
